import logo from './logo.svg';
import './App.css';
import Rocketie from './Test/Rocketie';
import New from './Test/New';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import CreateAccount from './Work/Create_account/CreateAccount';
import OrganizationRegistration from './Work/Job_seeker/OrganizationRegistration';
import Login from './Work/Login/Login';
import AgentLogin from './Work/Login/AgentLogin';
import LandingPage from './Work/LandingPage';
import AgentDashboard from './Work/Agent/AgentDashboard ';
import EmployerDashboard from './Work/Employer/EmployerDashboard';
import AttachmentOpportunities from './Work/Job_seeker/AttachmentOpportunitie';
import AccountDetails from './Work/Create_account/AccountDetails';
import AgentRegister from './Work/Agent/AgentRegister';
import StudentAgentFee from './Work/Agent/Agent_payment_option';

function App() {
  return (
    <div className="App">
     <BrowserRouter>

      <Routes>

        <Route path="/" element={<LandingPage />} />

        <Route path="/login" element={<Login />} />

        <Route path="/Create_account" element={<CreateAccount />} />

        <Route path="/agent" element={<AgentDashboard />} />

        <Route path="/employer" element={<EmployerDashboard />} />

        <Route path="/opportunities" element={<AttachmentOpportunities />} />

        <Route path="/my_account" element={<AccountDetails />} />

        <Route path="/Agent_create_account" element={<CreateAccount />} />

        <Route path="/Orgainsation_registration" element={<OrganizationRegistration/>} />

        <Route path="/Agent_login" element={<AgentLogin />} />

        <Route path="/Agent_regester" element={<AgentRegister />} />

      </Routes>

    </BrowserRouter>
    </div>
  );
}

export default App;
